import { Flex, IconButton, Button, Text } from '@radix-ui/themes';
import { PlusIcon, ArrowDownIcon } from '@radix-ui/react-icons';
import { useAgent } from '@getdutchie/agent-react';
import { AgentAssistIcon } from '@/ui/icons/agent-assist-icon';

interface HeaderProps {
  onClose?: () => void;
}

export function Header({ onClose }: HeaderProps) {
  const { messages, clearMessages } = useAgent();

  const isInChat = messages.length > 0;

  return (
    <Flex
      align="center"
      justify="between"
      px="4"
      pr="6"
      py="4"
      style={{
        borderBottom: '1px solid var(--gray-a4)',
        position: 'sticky',
        top: 0,
        zIndex: 10,
      }}
    >
      <Flex align="center" gap="1">
        <AgentAssistIcon size={40} />
        <Flex direction="column" gap="0">
          <Text size="3" weight="bold" style={{ color: '#005943' }}>
            Dutchie Agent
          </Text>
          <Text size="1" style={{ color: '#062f22' }}>
            Your intelligent supply chain copilot
          </Text>
        </Flex>
      </Flex>

      <Flex align="center" gap="4">
        {isInChat && (
          <>
            <Button variant="soft" color="gray" size="2" onClick={clearMessages}>
              <PlusIcon />
              New conversation
            </Button>
          </>
        )}
        {onClose && (
          <IconButton
            variant="outline"
            color="gray"
            size="1"
            onClick={onClose}
            aria-label="Close"
            radius="full"
            // highContrast
          >
            <ArrowDownIcon />
          </IconButton>
        )}
      </Flex>
    </Flex>
  );
}
